(function ($) {
    /**
     * Инициализация свайпера
     */
    var swiper = new Swiper ('.js-swiper-cup', {
        navigation: {
            nextEl: '.js-swiper-next',
            prevEl: '.js-swiper-prev',
        },
        watchOverflow: true,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        disabledClass: true,
        on: {
            init: function (swiper) {
                var startIndexSlide = parseInt(swiper.el.dataset.startIndex);
                if (startIndexSlide) {
                    swiper.slideTo(startIndexSlide);
                }
            },
            activeIndexChange: function (swiper) {
                var $block = $(swiper.el);
                var $gapRight = $block.find('.js-slide-gag-right');
                $gapRight.removeClass('hidden');

                if ($(swiper.navigation.nextEl).hasClass('swiper-button-disabled')) {
                    $gapRight.addClass('hidden');
                }
            },
            reachEnd: function (swiper) {
                var $block = $(swiper.el);
                var $gapRight = $block.find('.js-slide-gag-right');
                $gapRight.addClass('hidden');
            }
        }
    });
})(jQuery);
